module.exports = __webpack_public_path__ + "img/图1.1fd1b01a.png";